import { FC } from 'react';

import { Box, BoxProps } from '@qwealth/qcore';

import InfoTag from './SectionHeader/InfoTag';
import { sortStringsAlphabetically } from 'data/helpers/data';

interface TaskTagsListProps {
  tagsKey: string[] | undefined;
  hasLabel?: boolean;
  fontSize?: string;
  className?: string;
}

type CombinedProps = TaskTagsListProps & BoxProps;

const TaskTagsList: FC<CombinedProps> = ({ tagsKey, hasLabel = true, fontSize = 'default', className }) => {
  const hasTags = tagsKey && tagsKey.length > 0;
  const orderedTags = sortStringsAlphabetically(tagsKey || []);

  return (
    <>
      {hasTags ? (
        <Box display="flex" flexDirection="row" flexWrap="wrap" gap="small" alignItems="center" className={className}>
          {hasLabel && (
            <Box fontSize={fontSize} fontWeight="bold">
              Tags:
            </Box>
          )}

          {orderedTags.map(key => (
            <InfoTag key={`${key}`} tagTitle={'Task Tag'} taskTagTitle={key} fontSize={fontSize} />
          ))}
        </Box>
      ) : null}
    </>
  );
};

export default TaskTagsList;
